
































































import * as clickOutside from 'vue-click-outside';
import {
	defineComponent,
	nextTick,
	PropType,
	Ref,
	ref,
	watch,
} from '@vue/composition-api';
import { DirectiveOptions } from 'vue';
import FocusLoop from '@vue-a11y/focus-loop/src/FocusLoop.vue';
import { DropdownPosition } from './dropdownPosition';

let i = 0;
const uid = () => `dropdown${i++}`;

interface Style {
	opacity: number;
	top?: string;
	bottom?: string;
	left?: string;
	right?: string;
}

const OFF_STYLE: Style = {
	opacity: 0,
	left: '-1000%',
	right: '0',
	top: '0',
};

export default defineComponent({
	components: {
		FocusLoop,
	},
	directives: {
		clickOutside: clickOutside as DirectiveOptions,
	},
	props: {
		isOpen: {
			type: Boolean,
			required: true,
		},
		position: {
			type: Number as PropType<DropdownPosition>,
			default: DropdownPosition.BOTTOM_LEFT,
		},
		returnFocusTo: {
			type: String,
			default: '',
		},
		disableFocusLoop: Boolean,
		disableInitialFocus: Boolean,
		isFullWidth: Boolean,
		isTriggerFullWidth: Boolean,
		isMerged: Boolean,
	},
	setup(props, ctx) {
		const el = ref(null as null | HTMLElement);
		// "popupItem" is a special name used by the vue-click-outside directive,
		// it ignores clicks in the popupItem (they don't count as being "outside")
		const popupItem = ref(null as null | HTMLElement);
		const style: Ref<Style> = ref(OFF_STYLE);
		watch(() => props.isOpen, async () => {
			if (!props.isOpen) {
				style.value = OFF_STYLE;
				return;
			}
			// In a portal, we required 2 nextTicks
			await nextTick();
			await nextTick();
			// get rekt
			if (!el.value || !popupItem.value) {
				return;
			}
			switch (props.position) {
			case DropdownPosition.BOTTOM_LEFT:
				style.value = {
					opacity: 1,
					top: '100%',
					right: '0',
				};
				break;
			case DropdownPosition.BOTTOM_RIGHT:
				style.value = {
					opacity: 1,
					top: '100%',
					left: '0',
				};
				break;
			case DropdownPosition.TOP_RIGHT:
				style.value = {
					opacity: 1,
					bottom: '100%',
					left: '0',
				};
				break;
			default:
			}
		});

		const focusTrigger = () => {
			if (!el.value) {
				return;
			}
			const selector = props.returnFocusTo ? props.returnFocusTo : 'button,a,input';
			const button = el.value.querySelector(selector) as undefined | HTMLButtonElement;
			button?.focus();
		};

		return {
			uid: uid(),
			el,
			popupItem,
			style,
			focusTrigger,
			onClickOutside: () => {
				ctx.emit('close');
				ctx.emit('click-close');
			},
		};
	},
});
